export const ATTEMPT_STATUS = {
  completed: 'Completed',
  incomplete: 'In Progress',
  'not attempted': 'Not Started',
}
export const DATE_FORMAT = 'M/D/YYYY'
export const NO_DATA_PLACEHOLDER = 'N/A'
export const TOTAL_LESSONS = 27
export const SHOULD_SHOW_IN_MODAL = true
